export default __webpack_public_path__ + "static/media/yogabot-profesional.721db475.png";